import { get } from "lodash";
import * as CONSTANTS from "../../constants";

const initialState = {
  isLoading: false,
  errors: null,
  newPasswordData: {
    data: null,
  },
  validateNewPasswordToken: {
    data: null,
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.UPDATE_NEW_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: action.payload,
        errors: null,
        newPasswordData: {
          data: null,
        },
      }
    case CONSTANTS.UPDATE_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        newPasswordData: {
          data: action.payload,
        },
      }
    case CONSTANTS.UPDATE_NEW_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        newPasswordData: {
          data: null,
        },
      }
    case CONSTANTS.NEW_PASSWORD_TOKEN_VALID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        validateNewPasswordToken: {
          data: action.payload,
        },
      }
    case CONSTANTS.NEW_PASSWORD_TOKEN_VALID_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        validateNewPasswordToken: {
          data: null,
        },
      }
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'newPassword.isLoading');
export const getUpdatedNewPasswordSuccess = (state) => get(state, 'newPassword.newPasswordData.data');
export const getUpdatedNewPasswordErrors = (state) => get(state, 'newPassword.errors[0].error');
export const getValidateNewPasswordTokenSuccess = (state) => get(state, 'newPassword.validateNewPasswordToken.data');
